import { render } from "./Terms.vue?vue&type=template&id=411bbda6&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=411bbda6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411bbda6"]])

export default __exports__